import { combineReducers } from 'redux'

import { scheduleReducer } from './'
import { workorderReducer } from './workorder'

export const combinedWorkorderReducer = combineReducers({
    schedule: scheduleReducer,
    workorder: workorderReducer,
})
